import { FolderService } from "../../../services/folder.service";
import { FormInstanceService } from "../../../services/form-instance.service";
import { MoveOrCopyEnum, PerformActionParamObj, HomePageActionDialogReturnObj } from "../extras";
import { IHomePageAction } from "./i-home-page-action";
import { Form } from '../../../models/form-builder/form.model';
import { Folder } from '../../../models/site-content/folder.model';

export abstract class HomePageActionBase implements IHomePageAction{

    constructor() {
    }

    protected formInstanceService: FormInstanceService;
    protected folderService: FolderService;
    protected formInstanceGridRows: any[];
    protected siteId: number;
    protected formId: number;

    protected message: string;
    protected errorMessage: string;
    protected moveOrCopy: string;

    // Abstract methods
    abstract getTitle();
    abstract performAction(paramObj: PerformActionParamObj);
    abstract permissionsRequiredToPerform(): string;

    // Concrete methods
    public configure(formInstanceGridRows: any[], siteId: number, formId: number, formInstanceService: FormInstanceService, folderService: FolderService): void {
        this.formInstanceGridRows = formInstanceGridRows;
        this.formInstanceService = formInstanceService;
        this.folderService = folderService;
        this.siteId = siteId;
        this.formId = formId;
    }

    public requiresTree(): boolean {
        return false;
    }
    public requiresWritableRootNode(): boolean {
        return false;
    }
    public requiresFormTemplate(): boolean {
        return false;
    }

    public requiresCurrentFolder(): boolean {
        return false;
    }
    public setCurrentFolder(folder: Folder): void {
        // Note:  this method is a default NOOP implementation by design.
    }

    public setFormTemplate(formTemplate: Form): void {
        // Note:  this method is a default NOOP implementation by design.
    }

    public getSuggestedEntityName(): string {
        // Note:  this method is a default NOOP-like implementation by design.
        return null;
    }

    public hasDoneMessage(): boolean {
        return false;
    }

    public getMessage(): string {
        return this.message;
    }

    public getErrorMessage(): string {
        return this.errorMessage;
    }

    protected createRef(): boolean {
        return this.moveOrCopy == MoveOrCopyEnum.CREATE_REF;
    }

    protected copy() {
        return this.moveOrCopy == MoveOrCopyEnum.COPY;
    }

    protected move() {
        return this.moveOrCopy == MoveOrCopyEnum.MOVE;
    }

}
